import {Requests, defaultErrorHandler} from './base'


function modelsRequest ($parent, params = {}) {

  return Requests.get('/models', {params: params})
    .then(response => {
      $parent.loading.isActive = false
      return response.data
    })
    .catch(error => {
      return defaultErrorHandler(error, $parent)
    })
}

function bundlingRequest ($parent, param) {

  return Requests.post('/models/bundle', param)
    .then(response => {
      return response.data
    })
    .catch(error => {
      return defaultErrorHandler(error, $parent)
    })
}

function deleteBundleRequest ($parent, bundleID) {

  return Requests.delete('/models/bundle', {data: {bundle_id: bundleID}})
    .then(response => {
      return response.data
    })
    .catch(error => {
      return defaultErrorHandler(error, $parent)
    })
}


export {modelsRequest, bundlingRequest, deleteBundleRequest}



// WEBPACK FOOTER //
// ./src/modules/request/models.js